import { useStore } from "effector-react";
import { $isAudioLoading, $isAudioPlaying } from "./model";
export var useIsAudioPlaying = function () { return useStore($isAudioPlaying); };
export var useIsAudioLoading = function () { return useStore($isAudioLoading); };
export var useAudio = function () {
    var playing = useIsAudioPlaying();
    var loading = useIsAudioLoading();
    return { playing: playing, loading: loading };
};
